'use client';

import { usePathname } from 'next/navigation';

import { type BreadcrumbColorVariant, Breadcrumbs } from './Breadcrumbs';

interface BreadcrumbsFromUrlProps {
  colorVariant?: BreadcrumbColorVariant;
  className?: string;
}

const getSlugArray = (pathname: string): string[] => pathname.split('/').filter(Boolean);

const getTitleFromSlug = (slug: string): string =>
  slug
    .replaceAll('-', ' ')
    .replace(/[-_](.)/g, (_, char) => char.toUpperCase())
    .replace(/\b\w/g, char => char.toUpperCase());

export const BreadcrumbsFromUrl = ({
  colorVariant,
  className,
  ...rest
}: BreadcrumbsFromUrlProps) => {
  const pathname = usePathname();

  const slugArr = getSlugArray(pathname);
  let accumulatedPath = '';

  const breadcrumbsFromUrl = [
    { title: 'Naturaily', link: { href: '/' } },
    ...slugArr.map((path, i) => {
      const isNotLastItem = i < slugArr.length - 1;
      accumulatedPath += `/${path}`;

      return {
        title: getTitleFromSlug(path),
        ...(isNotLastItem && { link: { href: accumulatedPath } }),
      };
    }),
  ];

  return (
    <Breadcrumbs
      className={className}
      colorVariant={colorVariant}
      items={breadcrumbsFromUrl}
      {...rest}
    />
  );
};
